export enum DocumentPublishScope {
    LIST = "LIST",
    GET = "GET",
}
